module.exports = __webpack_public_path__ + "media/fonts/Rooftop-Bold-d163c81813a55dc97f482c8a56f6b718.otf";